import { useState, useEffect } from 'react';

export function useCountryList(channelPickerItems) {
    const resultList = channelPickerItems.map((item) => {
        return {
            label: item.CountryName,
            value: item.CountryId,
            currency: item.CurrencyString,
            countryCode: item.CountryCode,
        };
    });
    const [countryList, setCountryList] = useState(resultList);

    return [countryList, setCountryList];
}